import { useEffect, useState } from "react";

import "../../../css/components/Home/QuickView/QuickView.css"

// 數字動畫 Hook
const useCountUp = (target, duration = 800) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let start = 0;
    const step = Math.ceil(target / (duration / 16)); // 每幀增加量
    const timer = setInterval(() => {
      start += step;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(start);
      }
    }, 16);
    return () => clearInterval(timer);
  }, [target, duration]);
  return count;
};

const StatCard = ({ color, title, value, icon, href }) => {
  const animatedValue = useCountUp(value);

  return (
    <div className="col-xl-3 col-md-6 mb-4">
      <div className={`stat-card ${color}`}>
        <div className="card-body d-flex align-items-center">
          <div className="stat-icon rounded-circle d-flex justify-content-center align-items-center me-3">
            <i className={`fas ${icon} fa-lg`}></i>
          </div>
          <div>
            <h6 className="text-uppercase fw-semibold mb-1 opacity-75">{title}</h6>
            <h2 className="fw-bold mb-0">{animatedValue}</h2>
          </div>
        </div>
        <div className="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between">
          <a className="small text-white text-decoration-underline stat-link" href={href}>
            查看詳情
          </a>
          <i className="fas fa-angle-right stat-arrow"></i>
        </div>
      </div>
    </div>
  );
};

const QuickView = ({ data }) => {
  const [ordersData, setOrdersData] = useState([]);

  useEffect(() => {
    if (data) setOrdersData(data);
  }, [data]);

  const totalOrders = ordersData.length;
  const unReviewed = ordersData.filter((item) => item.status === 0).length;
  const reviewedUnshipped = ordersData.filter(
    (item) => item.status === 1 && item.isShipped === 0
  ).length;
  const today = new Date().toISOString().slice(0, 10);
  const todayDelivery = ordersData.filter(
    (item) => item.deliveryDate?.slice(0, 10) === today && item.status === 1
  ).length;

  return (
    <div className="quickview row g-4">
      <StatCard color="primary" title="總訂單數" value={totalOrders} icon="fa-boxes" href={'OrderInfo'} />
      <StatCard color="danger" title="未審核訂單" value={unReviewed} icon="fa-times-circle" href={'OrderInfo?review=unReviewed'} />
      <StatCard color="warning" title="已審未寄送" value={reviewedUnshipped} icon="fa-truck-loading" href={'OrderInfo?status=notShipped&review=approved'} />
      <StatCard color="success" title="今日寄送" value={todayDelivery} icon="fa-truck" href={`OrderInfo?start=${today}&end=${today}&review=approved`} />
    </div>
  );
};

export { QuickView };
